export type { IArtist } from "./interfaces";
export { useGetArtists } from "./useGetArtists";
